// extracted by mini-css-extract-plugin
export default {"box":"siteholder_box__LFgpf","black":"siteholder_black__9aZ-W","white":"siteholder_white__6W28R","img":"siteholder_img__AX8O5","zoomin":"siteholder_zoomin__R7UKj"};